import React from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { IStoreState } from '../store/states'

/**
 * Compatibility layer for React Router v5 → v6 migration.
 * Provides a connect HOC 
 * so class components continue working without rewriting.
 */

export function connectRedux<TStateProps extends object>(
  mapStateToProps: ((state: IStoreState) => TStateProps) | null,
  Component: React.ComponentType<any>
): React.ComponentType<any> {
  function ConnectedComponent(ownProps: any) {
    const stateProps = mapStateToProps ? useSelector(mapStateToProps, shallowEqual) : {}
    const dispatch = useDispatch()
    return <Component {...ownProps} {...(stateProps as TStateProps)} dispatch={dispatch} />
  }

  const displayName = (Component as any).displayName || (Component as any).name || 'Component'
  ConnectedComponent.displayName = `connectRedux(${displayName})`

  return ConnectedComponent
}
